import { useAppContext } from '../contexts/AppContext'
import { processReplacements } from '../utils/processReplacements'

function useVars(srtWithVar: string) {
  const { questionsWithCode } = useAppContext()
  return processReplacements(srtWithVar, questionsWithCode) || ''
}

export default useVars
